import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for deviceStatuses.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.DEVICE_STATUSES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const DeviceStatusService = {
  FindMany
}

export default DeviceStatusService
